<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import RegisterForm from './RegisterForm'

  export default {
    name: 'HeroRegisterModule',
    components: {
      RegisterForm,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
    computed: {
      ...mapState('auth', [ 'signup_config' ]),
    },
  }
</script>
